@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.feed.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.feed.resources/"

@delegate:ResourceContentHash(2_145_818_250)
internal val Res.string.feed_action_failed: StringResource by lazy {
      StringResource("string:feed_action_failed", "feed_action_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 301, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 221, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 165, 82),
      ))
    }

@delegate:ResourceContentHash(-81_181_810)
internal val Res.string.feed_block_confirm: StringResource by lazy {
      StringResource("string:feed_block_confirm", "feed_block_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 408, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 300, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 248, 34),
      ))
    }

@delegate:ResourceContentHash(708_840_860)
internal val Res.string.feed_block_message: StringResource by lazy {
      StringResource("string:feed_block_message", "feed_block_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 463, 238),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 339, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 283, 138),
      ))
    }

@delegate:ResourceContentHash(-1_985_525_260)
internal val Res.string.feed_block_title: StringResource by lazy {
      StringResource("string:feed_block_title", "feed_block_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 702, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 502, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 422, 40),
      ))
    }

@delegate:ResourceContentHash(1_867_597_297)
internal val Res.string.feed_block_user_a11y: StringResource by lazy {
      StringResource("string:feed_block_user_a11y", "feed_block_user_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 759, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 547, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 463, 44),
      ))
    }

@delegate:ResourceContentHash(-1_100_109_919)
internal val Res.string.feed_card_image_a11y: StringResource by lazy {
      StringResource("string:feed_card_image_a11y", "feed_card_image_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 828, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 608, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 508, 48),
      ))
    }

@delegate:ResourceContentHash(886_819_637)
internal val Res.string.feed_comment_a11y: StringResource by lazy {
      StringResource("string:feed_comment_a11y", "feed_comment_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 877, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 657, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 557, 45),
      ))
    }

@delegate:ResourceContentHash(-1_677_783_044)
internal val Res.string.feed_comment_delete_failed: StringResource by lazy {
      StringResource("string:feed_comment_delete_failed", "feed_comment_delete_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 943, 114),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 711, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 603, 94),
      ))
    }

@delegate:ResourceContentHash(966_047_907)
internal val Res.string.feed_comment_empty: StringResource by lazy {
      StringResource("string:feed_comment_empty", "feed_comment_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1058, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 818, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 698, 86),
      ))
    }

@delegate:ResourceContentHash(2_045_251_588)
internal val Res.string.feed_comment_failed: StringResource by lazy {
      StringResource("string:feed_comment_failed", "feed_comment_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1189, 123),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 905, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 785, 87),
      ))
    }

@delegate:ResourceContentHash(1_231_375_898)
internal val Res.string.feed_comment_placeholder: StringResource by lazy {
      StringResource("string:feed_comment_placeholder", "feed_comment_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1313, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1005, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 873, 56),
      ))
    }

@delegate:ResourceContentHash(-72_920_175)
internal val Res.string.feed_comment_recommended_a11y: StringResource by lazy {
      StringResource("string:feed_comment_recommended_a11y", "feed_comment_recommended_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1390, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1074, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 930, 65),
      ))
    }

@delegate:ResourceContentHash(1_951_398_466)
internal val Res.string.feed_comment_report_action: StringResource by lazy {
      StringResource("string:feed_comment_report_action", "feed_comment_report_action", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1480, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1144, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 996, 54),
      ))
    }

@delegate:ResourceContentHash(-1_093_569_820)
internal val Res.string.feed_comment_report_sent: StringResource by lazy {
      StringResource("string:feed_comment_report_sent", "feed_comment_report_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1547, 148),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1211, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1051, 92),
      ))
    }

@delegate:ResourceContentHash(211_450_587)
internal val Res.string.feed_comment_report_title: StringResource by lazy {
      StringResource("string:feed_comment_report_title", "feed_comment_report_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1696, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1312, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1144, 61),
      ))
    }

@delegate:ResourceContentHash(2_138_116_757)
internal val Res.string.feed_comment_send: StringResource by lazy {
      StringResource("string:feed_comment_send", "feed_comment_send", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1770, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1378, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1206, 33),
      ))
    }

@delegate:ResourceContentHash(-233_478_679)
internal val Res.string.feed_comments_title: StringResource by lazy {
      StringResource("string:feed_comments_title", "feed_comments_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1812, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1416, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1240, 39),
      ))
    }

@delegate:ResourceContentHash(1_814_514_755)
internal val Res.string.feed_community_empty_desc: StringResource by lazy {
      StringResource("string:feed_community_empty_desc", "feed_community_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 1868, 217),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1460, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1280, 125),
      ))
    }

@delegate:ResourceContentHash(1_199_473_509)
internal val Res.string.feed_community_empty_title: StringResource by lazy {
      StringResource("string:feed_community_empty_title", "feed_community_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2086, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1602, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1406, 58),
      ))
    }

@delegate:ResourceContentHash(1_512_422_595)
internal val Res.string.feed_composer_add_photo: StringResource by lazy {
      StringResource("string:feed_composer_add_photo", "feed_composer_add_photo", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2157, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1665, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1465, 47),
      ))
    }

@delegate:ResourceContentHash(548_182_429)
internal val Res.string.feed_composer_photo_attached: StringResource by lazy {
      StringResource("string:feed_composer_photo_attached", "feed_composer_photo_attached", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2217, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1721, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1513, 56),
      ))
    }

@delegate:ResourceContentHash(-1_425_296_033)
internal val Res.string.feed_composer_placeholder: StringResource by lazy {
      StringResource("string:feed_composer_placeholder", "feed_composer_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2286, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1774, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1570, 81),
      ))
    }

@delegate:ResourceContentHash(-272_702_183)
internal val Res.string.feed_composer_publish: StringResource by lazy {
      StringResource("string:feed_composer_publish", "feed_composer_publish", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2412, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1868, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1652, 37),
      ))
    }

@delegate:ResourceContentHash(-2_053_450_183)
internal val Res.string.feed_deal_badge: StringResource by lazy {
      StringResource("string:feed_deal_badge", "feed_deal_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2458, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1910, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1690, 31),
      ))
    }

@delegate:ResourceContentHash(-1_290_417_592)
internal val Res.string.feed_deal_ends_days: StringResource by lazy {
      StringResource("string:feed_deal_ends_days", "feed_deal_ends_days", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2502, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 1942, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1722, 51),
      ))
    }

@delegate:ResourceContentHash(1_312_398_796)
internal val Res.string.feed_deal_ends_today: StringResource by lazy {
      StringResource("string:feed_deal_ends_today", "feed_deal_ends_today", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2590, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2006, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1774, 44),
      ))
    }

@delegate:ResourceContentHash(1_919_204_439)
internal val Res.string.feed_deal_view: StringResource by lazy {
      StringResource("string:feed_deal_view", "feed_deal_view", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2663, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2067, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1819, 38),
      ))
    }

@delegate:ResourceContentHash(339_358_431)
internal val Res.string.feed_delete_cancel: StringResource by lazy {
      StringResource("string:feed_delete_cancel", "feed_delete_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2726, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2110, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1858, 34),
      ))
    }

@delegate:ResourceContentHash(-1_637_368_451)
internal val Res.string.feed_delete_comment_a11y: StringResource by lazy {
      StringResource("string:feed_delete_comment_a11y", "feed_delete_comment_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2769, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2149, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1893, 52),
      ))
    }

@delegate:ResourceContentHash(-899_515_545)
internal val Res.string.feed_delete_comment_message: StringResource by lazy {
      StringResource("string:feed_delete_comment_message", "feed_delete_comment_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2830, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2214, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1946, 87),
      ))
    }

@delegate:ResourceContentHash(1_001_976_050)
internal val Res.string.feed_delete_comment_title: StringResource by lazy {
      StringResource("string:feed_delete_comment_title", "feed_delete_comment_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 2974, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2314, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2034, 61),
      ))
    }

@delegate:ResourceContentHash(2_049_085_911)
internal val Res.string.feed_delete_confirm: StringResource by lazy {
      StringResource("string:feed_delete_confirm", "feed_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3056, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2384, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2096, 35),
      ))
    }

@delegate:ResourceContentHash(-847_244_219)
internal val Res.string.feed_delete_post_a11y: StringResource by lazy {
      StringResource("string:feed_delete_post_a11y", "feed_delete_post_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3092, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2424, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2132, 45),
      ))
    }

@delegate:ResourceContentHash(-1_681_046_194)
internal val Res.string.feed_delete_post_message: StringResource by lazy {
      StringResource("string:feed_delete_post_message", "feed_delete_post_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3142, 232),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2486, 156),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2178, 128),
      ))
    }

@delegate:ResourceContentHash(1_230_118_676)
internal val Res.string.feed_delete_post_title: StringResource by lazy {
      StringResource("string:feed_delete_post_title", "feed_delete_post_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3375, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2643, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2307, 54),
      ))
    }

@delegate:ResourceContentHash(903_440_835)
internal val Res.string.feed_edit_post_a11y: StringResource by lazy {
      StringResource("string:feed_edit_post_a11y", "feed_edit_post_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3446, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2714, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2362, 39),
      ))
    }

@delegate:ResourceContentHash(1_020_354_813)
internal val Res.string.feed_edit_post_save: StringResource by lazy {
      StringResource("string:feed_edit_post_save", "feed_edit_post_save", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3502, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2774, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2402, 43),
      ))
    }

@delegate:ResourceContentHash(903_440_835)
internal val Res.string.feed_edit_post_title: StringResource by lazy {
      StringResource("string:feed_edit_post_title", "feed_edit_post_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3566, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2818, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2446, 40),
      ))
    }

@delegate:ResourceContentHash(-2_074_630_836)
internal val Res.string.feed_empty_desc: StringResource by lazy {
      StringResource("string:feed_empty_desc", "feed_empty_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3623, 195),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2879, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2487, 111),
      ))
    }

@delegate:ResourceContentHash(-1_309_126_362)
internal val Res.string.feed_empty_title: StringResource by lazy {
      StringResource("string:feed_empty_title", "feed_empty_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3819, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 2999, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2599, 60),
      ))
    }

@delegate:ResourceContentHash(-1_796_015_779)
internal val Res.string.feed_error: StringResource by lazy {
      StringResource("string:feed_error", "feed_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3876, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3064, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2660, 50),
      ))
    }

@delegate:ResourceContentHash(1_829_074_531)
internal val Res.string.feed_event_am: StringResource by lazy {
      StringResource("string:feed_event_am", "feed_event_am", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3959, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3123, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2711, 25),
      ))
    }

@delegate:ResourceContentHash(-2_006_744_691)
internal val Res.string.feed_event_date_format: StringResource by lazy {
      StringResource("string:feed_event_date_format", "feed_event_date_format", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 3989, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3149, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2737, 70),
      ))
    }

@delegate:ResourceContentHash(1_264_996_664)
internal val Res.string.feed_event_details: StringResource by lazy {
      StringResource("string:feed_event_details", "feed_event_details", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4060, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3220, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2808, 38),
      ))
    }

@delegate:ResourceContentHash(-1_195_797_487)
internal val Res.string.feed_event_going: StringResource by lazy {
      StringResource("string:feed_event_going", "feed_event_going", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4103, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3259, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2847, 40),
      ))
    }

@delegate:ResourceContentHash(2_111_656_951)
internal val Res.string.feed_event_pm: StringResource by lazy {
      StringResource("string:feed_event_pm", "feed_event_pm", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4164, 29),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3308, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2888, 25),
      ))
    }

@delegate:ResourceContentHash(-1_257_348_755)
internal val Res.string.feed_filter_all: StringResource by lazy {
      StringResource("string:feed_filter_all", "feed_filter_all", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4194, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3334, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2914, 27),
      ))
    }

@delegate:ResourceContentHash(-535_239_523)
internal val Res.string.feed_filter_deals: StringResource by lazy {
      StringResource("string:feed_filter_deals", "feed_filter_deals", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4226, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3366, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2942, 33),
      ))
    }

@delegate:ResourceContentHash(725_148_440)
internal val Res.string.feed_filter_events: StringResource by lazy {
      StringResource("string:feed_filter_events", "feed_filter_events", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4276, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3400, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2976, 34),
      ))
    }

@delegate:ResourceContentHash(827_678_368)
internal val Res.string.feed_filter_new: StringResource by lazy {
      StringResource("string:feed_filter_new", "feed_filter_new", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4327, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3443, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3011, 27),
      ))
    }

@delegate:ResourceContentHash(1_241_412_880)
internal val Res.string.feed_follow: StringResource by lazy {
      StringResource("string:feed_follow", "feed_follow", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4426, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3518, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3074, 27),
      ))
    }

@delegate:ResourceContentHash(1_976_169_267)
internal val Res.string.feed_following: StringResource by lazy {
      StringResource("string:feed_following", "feed_following", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4367, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3483, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3039, 34),
      ))
    }

@delegate:ResourceContentHash(-261_253_677)
internal val Res.string.feed_kicker_deal: StringResource by lazy {
      StringResource("string:feed_kicker_deal", "feed_kicker_deal", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4474, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3546, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3102, 44),
      ))
    }

@delegate:ResourceContentHash(110_591_383)
internal val Res.string.feed_kicker_event: StringResource by lazy {
      StringResource("string:feed_kicker_event", "feed_kicker_event", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4531, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3591, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3147, 33),
      ))
    }

@delegate:ResourceContentHash(-1_873_920_684)
internal val Res.string.feed_kicker_new: StringResource by lazy {
      StringResource("string:feed_kicker_new", "feed_kicker_new", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4573, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3633, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3181, 39),
      ))
    }

@delegate:ResourceContentHash(964_318_236)
internal val Res.string.feed_like_a11y: StringResource by lazy {
      StringResource("string:feed_like_a11y", "feed_like_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4633, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3677, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3221, 34),
      ))
    }

@delegate:ResourceContentHash(1_573_729_766)
internal val Res.string.feed_load_older: StringResource by lazy {
      StringResource("string:feed_load_older", "feed_load_older", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4684, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3728, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3256, 47),
      ))
    }

@delegate:ResourceContentHash(-1_571_576_567)
internal val Res.string.feed_more_actions_a11y: StringResource by lazy {
      StringResource("string:feed_more_actions_a11y", "feed_more_actions_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4768, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3804, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3304, 46),
      ))
    }

@delegate:ResourceContentHash(-1_765_305_285)
internal val Res.string.feed_new_in_city: StringResource by lazy {
      StringResource("string:feed_new_in_city", "feed_new_in_city", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4839, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3859, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3351, 40),
      ))
    }

@delegate:ResourceContentHash(1_344_675_889)
internal val Res.string.feed_new_view: StringResource by lazy {
      StringResource("string:feed_new_view", "feed_new_view", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4888, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3904, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3392, 37),
      ))
    }

@delegate:ResourceContentHash(964_243_478)
internal val Res.string.feed_post_failed: StringResource by lazy {
      StringResource("string:feed_post_failed", "feed_post_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 4954, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 3946, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3430, 76),
      ))
    }

@delegate:ResourceContentHash(-24_210_211)
internal val Res.string.feed_post_photo_a11y: StringResource by lazy {
      StringResource("string:feed_post_photo_a11y", "feed_post_photo_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5071, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4035, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3507, 44),
      ))
    }

@delegate:ResourceContentHash(-403_839_900)
internal val Res.string.feed_recommend_attached: StringResource by lazy {
      StringResource("string:feed_recommend_attached", "feed_recommend_attached", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5120, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4096, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3552, 55),
      ))
    }

@delegate:ResourceContentHash(-158_470_447)
internal val Res.string.feed_recommend_business: StringResource by lazy {
      StringResource("string:feed_recommend_business", "feed_recommend_business", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5180, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4148, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3608, 59),
      ))
    }

@delegate:ResourceContentHash(27_360_373)
internal val Res.string.feed_recommend_search: StringResource by lazy {
      StringResource("string:feed_recommend_search", "feed_recommend_search", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5264, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4216, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3668, 61),
      ))
    }

@delegate:ResourceContentHash(-158_470_447)
internal val Res.string.feed_recommend_title: StringResource by lazy {
      StringResource("string:feed_recommend_title", "feed_recommend_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5334, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4290, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3730, 56),
      ))
    }

@delegate:ResourceContentHash(1_950_060_841)
internal val Res.string.feed_report_action: StringResource by lazy {
      StringResource("string:feed_report_action", "feed_report_action", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5415, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4355, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3787, 42),
      ))
    }

@delegate:ResourceContentHash(-481_935_050)
internal val Res.string.feed_report_done: StringResource by lazy {
      StringResource("string:feed_report_done", "feed_report_done", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5466, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4414, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3830, 32),
      ))
    }

@delegate:ResourceContentHash(-1_500_097_184)
internal val Res.string.feed_report_failed: StringResource by lazy {
      StringResource("string:feed_report_failed", "feed_report_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5503, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4451, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3863, 82),
      ))
    }

@delegate:ResourceContentHash(-395_251_490)
internal val Res.string.feed_report_reason_harassment: StringResource by lazy {
      StringResource("string:feed_report_reason_harassment", "feed_report_reason_harassment", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5626, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4550, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3946, 69),
      ))
    }

@delegate:ResourceContentHash(1_823_354_768)
internal val Res.string.feed_report_reason_misinformation: StringResource by lazy {
      StringResource("string:feed_report_reason_misinformation", "feed_report_reason_misinformation", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5696, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4628, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4016, 65),
      ))
    }

@delegate:ResourceContentHash(-2_069_144_880)
internal val Res.string.feed_report_reason_offensive: StringResource by lazy {
      StringResource("string:feed_report_reason_offensive", "feed_report_reason_offensive", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5774, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4694, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4082, 64),
      ))
    }

@delegate:ResourceContentHash(1_511_516_124)
internal val Res.string.feed_report_reason_spam: StringResource by lazy {
      StringResource("string:feed_report_reason_spam", "feed_report_reason_spam", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5879, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4759, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4147, 59),
      ))
    }

@delegate:ResourceContentHash(959_857_193)
internal val Res.string.feed_report_sent: StringResource by lazy {
      StringResource("string:feed_report_sent", "feed_report_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 5959, 132),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4823, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4207, 80),
      ))
    }

@delegate:ResourceContentHash(-1_054_499_435)
internal val Res.string.feed_report_submit: StringResource by lazy {
      StringResource("string:feed_report_submit", "feed_report_submit", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6092, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4920, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4288, 46),
      ))
    }

@delegate:ResourceContentHash(1_220_303_239)
internal val Res.string.feed_report_title: StringResource by lazy {
      StringResource("string:feed_report_title", "feed_report_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6147, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 4979, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4335, 49),
      ))
    }

@delegate:ResourceContentHash(-2_029_959_231)
internal val Res.string.feed_retry: StringResource by lazy {
      StringResource("string:feed_retry", "feed_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6205, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5041, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4385, 30),
      ))
    }

@delegate:ResourceContentHash(1_558_967_519)
internal val Res.string.feed_save_a11y: StringResource by lazy {
      StringResource("string:feed_save_a11y", "feed_save_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6252, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5076, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4416, 34),
      ))
    }

@delegate:ResourceContentHash(1_121_437_104)
internal val Res.string.feed_share_a11y: StringResource by lazy {
      StringResource("string:feed_share_a11y", "feed_share_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6299, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5135, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4451, 39),
      ))
    }

@delegate:ResourceContentHash(337_430_569)
internal val Res.string.feed_sort_most_liked: StringResource by lazy {
      StringResource("string:feed_sort_most_liked", "feed_sort_most_liked", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6355, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5191, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4491, 44),
      ))
    }

@delegate:ResourceContentHash(101_137_762)
internal val Res.string.feed_sort_newest: StringResource by lazy {
      StringResource("string:feed_sort_newest", "feed_sort_newest", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6412, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5240, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4536, 32),
      ))
    }

@delegate:ResourceContentHash(101_855_719)
internal val Res.string.feed_sort_photos: StringResource by lazy {
      StringResource("string:feed_sort_photos", "feed_sort_photos", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6461, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5285, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4569, 40),
      ))
    }

@delegate:ResourceContentHash(2_115_255_678)
internal val Res.string.feed_suggested_title: StringResource by lazy {
      StringResource("string:feed_suggested_title", "feed_suggested_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6502, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5326, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4610, 52),
      ))
    }

@delegate:ResourceContentHash(812_158_875)
internal val Res.string.feed_time_days_ago: StringResource by lazy {
      StringResource("string:feed_time_days_ago", "feed_time_days_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6571, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5383, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4663, 42),
      ))
    }

@delegate:ResourceContentHash(2_094_969_652)
internal val Res.string.feed_time_hours_ago: StringResource by lazy {
      StringResource("string:feed_time_hours_ago", "feed_time_hours_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6622, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5430, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4706, 43),
      ))
    }

@delegate:ResourceContentHash(-2_012_089_126)
internal val Res.string.feed_time_just_now: StringResource by lazy {
      StringResource("string:feed_time_just_now", "feed_time_just_now", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6678, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5478, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4750, 38),
      ))
    }

@delegate:ResourceContentHash(-1_591_511_977)
internal val Res.string.feed_time_minutes_ago: StringResource by lazy {
      StringResource("string:feed_time_minutes_ago", "feed_time_minutes_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6729, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5525, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4789, 45),
      ))
    }

@delegate:ResourceContentHash(-1_205_191_231)
internal val Res.string.feed_time_weeks_ago: StringResource by lazy {
      StringResource("string:feed_time_weeks_ago", "feed_time_weeks_ago", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6791, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5575, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4835, 43),
      ))
    }

@delegate:ResourceContentHash(-366_147_393)
internal val Res.string.feed_title: StringResource by lazy {
      StringResource("string:feed_title", "feed_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6847, 34),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5627, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4879, 30),
      ))
    }

@delegate:ResourceContentHash(498_961_601)
internal val Res.string.feed_trending_title: StringResource by lazy {
      StringResource("string:feed_trending_title", "feed_trending_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6882, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5662, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4910, 51),
      ))
    }

@delegate:ResourceContentHash(-2_054_097_616)
internal val Res.string.feed_type_general: StringResource by lazy {
      StringResource("string:feed_type_general", "feed_type_general", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 6954, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5722, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4962, 33),
      ))
    }

@delegate:ResourceContentHash(-201_025_254)
internal val Res.string.feed_type_question: StringResource by lazy {
      StringResource("string:feed_type_question", "feed_type_question", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7000, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5764, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4996, 38),
      ))
    }

@delegate:ResourceContentHash(1_034_606_584)
internal val Res.string.feed_type_recommendation: StringResource by lazy {
      StringResource("string:feed_type_recommendation", "feed_type_recommendation", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7039, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5803, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5035, 52),
      ))
    }

@delegate:ResourceContentHash(-1_885_003_748)
internal val Res.string.feed_unlike_a11y: StringResource by lazy {
      StringResource("string:feed_unlike_a11y", "feed_unlike_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7092, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5856, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5088, 40),
      ))
    }

@delegate:ResourceContentHash(836_451_313)
internal val Res.string.feed_unsave_a11y: StringResource by lazy {
      StringResource("string:feed_unsave_a11y", "feed_unsave_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7149, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 5921, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5129, 48),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feed_action_failed", Res.string.feed_action_failed)
  map.put("feed_block_confirm", Res.string.feed_block_confirm)
  map.put("feed_block_message", Res.string.feed_block_message)
  map.put("feed_block_title", Res.string.feed_block_title)
  map.put("feed_block_user_a11y", Res.string.feed_block_user_a11y)
  map.put("feed_card_image_a11y", Res.string.feed_card_image_a11y)
  map.put("feed_comment_a11y", Res.string.feed_comment_a11y)
  map.put("feed_comment_delete_failed", Res.string.feed_comment_delete_failed)
  map.put("feed_comment_empty", Res.string.feed_comment_empty)
  map.put("feed_comment_failed", Res.string.feed_comment_failed)
  map.put("feed_comment_placeholder", Res.string.feed_comment_placeholder)
  map.put("feed_comment_recommended_a11y", Res.string.feed_comment_recommended_a11y)
  map.put("feed_comment_report_action", Res.string.feed_comment_report_action)
  map.put("feed_comment_report_sent", Res.string.feed_comment_report_sent)
  map.put("feed_comment_report_title", Res.string.feed_comment_report_title)
  map.put("feed_comment_send", Res.string.feed_comment_send)
  map.put("feed_comments_title", Res.string.feed_comments_title)
  map.put("feed_community_empty_desc", Res.string.feed_community_empty_desc)
  map.put("feed_community_empty_title", Res.string.feed_community_empty_title)
  map.put("feed_composer_add_photo", Res.string.feed_composer_add_photo)
  map.put("feed_composer_photo_attached", Res.string.feed_composer_photo_attached)
  map.put("feed_composer_placeholder", Res.string.feed_composer_placeholder)
  map.put("feed_composer_publish", Res.string.feed_composer_publish)
  map.put("feed_deal_badge", Res.string.feed_deal_badge)
  map.put("feed_deal_ends_days", Res.string.feed_deal_ends_days)
  map.put("feed_deal_ends_today", Res.string.feed_deal_ends_today)
  map.put("feed_deal_view", Res.string.feed_deal_view)
  map.put("feed_delete_cancel", Res.string.feed_delete_cancel)
  map.put("feed_delete_comment_a11y", Res.string.feed_delete_comment_a11y)
  map.put("feed_delete_comment_message", Res.string.feed_delete_comment_message)
  map.put("feed_delete_comment_title", Res.string.feed_delete_comment_title)
  map.put("feed_delete_confirm", Res.string.feed_delete_confirm)
  map.put("feed_delete_post_a11y", Res.string.feed_delete_post_a11y)
  map.put("feed_delete_post_message", Res.string.feed_delete_post_message)
  map.put("feed_delete_post_title", Res.string.feed_delete_post_title)
  map.put("feed_edit_post_a11y", Res.string.feed_edit_post_a11y)
  map.put("feed_edit_post_save", Res.string.feed_edit_post_save)
  map.put("feed_edit_post_title", Res.string.feed_edit_post_title)
  map.put("feed_empty_desc", Res.string.feed_empty_desc)
  map.put("feed_empty_title", Res.string.feed_empty_title)
  map.put("feed_error", Res.string.feed_error)
  map.put("feed_event_am", Res.string.feed_event_am)
  map.put("feed_event_date_format", Res.string.feed_event_date_format)
  map.put("feed_event_details", Res.string.feed_event_details)
  map.put("feed_event_going", Res.string.feed_event_going)
  map.put("feed_event_pm", Res.string.feed_event_pm)
  map.put("feed_filter_all", Res.string.feed_filter_all)
  map.put("feed_filter_deals", Res.string.feed_filter_deals)
  map.put("feed_filter_events", Res.string.feed_filter_events)
  map.put("feed_filter_new", Res.string.feed_filter_new)
  map.put("feed_follow", Res.string.feed_follow)
  map.put("feed_following", Res.string.feed_following)
  map.put("feed_kicker_deal", Res.string.feed_kicker_deal)
  map.put("feed_kicker_event", Res.string.feed_kicker_event)
  map.put("feed_kicker_new", Res.string.feed_kicker_new)
  map.put("feed_like_a11y", Res.string.feed_like_a11y)
  map.put("feed_load_older", Res.string.feed_load_older)
  map.put("feed_more_actions_a11y", Res.string.feed_more_actions_a11y)
  map.put("feed_new_in_city", Res.string.feed_new_in_city)
  map.put("feed_new_view", Res.string.feed_new_view)
  map.put("feed_post_failed", Res.string.feed_post_failed)
  map.put("feed_post_photo_a11y", Res.string.feed_post_photo_a11y)
  map.put("feed_recommend_attached", Res.string.feed_recommend_attached)
  map.put("feed_recommend_business", Res.string.feed_recommend_business)
  map.put("feed_recommend_search", Res.string.feed_recommend_search)
  map.put("feed_recommend_title", Res.string.feed_recommend_title)
  map.put("feed_report_action", Res.string.feed_report_action)
  map.put("feed_report_done", Res.string.feed_report_done)
  map.put("feed_report_failed", Res.string.feed_report_failed)
  map.put("feed_report_reason_harassment", Res.string.feed_report_reason_harassment)
  map.put("feed_report_reason_misinformation", Res.string.feed_report_reason_misinformation)
  map.put("feed_report_reason_offensive", Res.string.feed_report_reason_offensive)
  map.put("feed_report_reason_spam", Res.string.feed_report_reason_spam)
  map.put("feed_report_sent", Res.string.feed_report_sent)
  map.put("feed_report_submit", Res.string.feed_report_submit)
  map.put("feed_report_title", Res.string.feed_report_title)
  map.put("feed_retry", Res.string.feed_retry)
  map.put("feed_save_a11y", Res.string.feed_save_a11y)
  map.put("feed_share_a11y", Res.string.feed_share_a11y)
  map.put("feed_sort_most_liked", Res.string.feed_sort_most_liked)
  map.put("feed_sort_newest", Res.string.feed_sort_newest)
  map.put("feed_sort_photos", Res.string.feed_sort_photos)
  map.put("feed_suggested_title", Res.string.feed_suggested_title)
  map.put("feed_time_days_ago", Res.string.feed_time_days_ago)
  map.put("feed_time_hours_ago", Res.string.feed_time_hours_ago)
  map.put("feed_time_just_now", Res.string.feed_time_just_now)
  map.put("feed_time_minutes_ago", Res.string.feed_time_minutes_ago)
  map.put("feed_time_weeks_ago", Res.string.feed_time_weeks_ago)
  map.put("feed_title", Res.string.feed_title)
  map.put("feed_trending_title", Res.string.feed_trending_title)
  map.put("feed_type_general", Res.string.feed_type_general)
  map.put("feed_type_question", Res.string.feed_type_question)
  map.put("feed_type_recommendation", Res.string.feed_type_recommendation)
  map.put("feed_unlike_a11y", Res.string.feed_unlike_a11y)
  map.put("feed_unsave_a11y", Res.string.feed_unsave_a11y)
}
